var getOs = function () {
    var os = ['Windows', 'Linux', 'Mac']; // add your OS values
    return os.find(function (v) { return navigator.appVersion.indexOf(v) >= 0; });
};
export default getOs;
